<template>
  <div class="createSuccess">
    <div class="main">
        <div class="success">
            <div class="icon"></div>
            <p class="msg">参保成功</p>   
            <p class="msg2">WiFi安全险保障中</p>   
            
        </div>
        <div class="btn" @click="toindex()">
            查看我的保单
        </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'createSuccess',
    mounted:function(){
        if(WiFikey && WiFikey.startComponent){
           WiFikey.startComponent(JSON.stringify({
               aciton:'wifi.intent.action.WIFI_INSURANCE_ACTIVATED',
               type:2,
               ext:'1'
           }));
        }
        if(localStorage.channel && localStorage.channel == 'tj_freepro'){
            // Utils.Tracker.send({
            //     data: {
            //         f: 'wifiins',
            //         b: 'tjpro_suc'
            //     }
            // });
        }else{
            // Utils.Tracker.send({
            //     data: {
            //         f: 'wifiins',
            //         b: 'pro_suc'
            //     }
            // });
        }
    },
    methods:{
        toindex(){
            // Utils.Tracker.send({
            //     data: {
            //         f: 'wifiins',
            //         b: 'check_pro'
            //     }
            // });
            this.$router.push("/index");
        }
    }
}
</script>

<style scoped>
.main{margin-top: 15px;text-align: center}
.logo{width: 60%;}
.main .success{
    position: fixed;
    width: 100%;
    top: 20%;
}
.main .success .icon{
    width: 53.86667%;
    padding-top: 44.8%;
    margin: 0 auto;
    background-image: url(../images/index/chenggong.png);
    background-repeat: no-repeat;
    -webkit-background-size: 100%;
        background-size: 100%;    
}
.main .msg{text-align: center; width: 100%;padding: 0;font-size: 20px;color: #0285F0;line-height: 26px;margin-top: 33px;}
.main .msg2{text-align: center; width: 100%;padding: 0;font-size: 14px;color: #000;line-height: 26px;font-weight: 300}
.main a{text-decoration: none;font-size: 13px;margin-top: 16px;}
    .btn{
        position: fixed;
        left:50%;
        bottom: 5%;
        height: 42px;
        width: 70.6667%;
        transform: translateX(-50%);
        text-decoration: none;
        font-size: 16px;
        line-height: 42px;
        text-align: center;
        margin: 0 auto;
        -webkit-border-radius: 23px;
        -moz-border-radius: 23px;
        border-radius: 23px;
        color: #ffffff;
        background:#0285F0
    }
</style>



// WEBPACK FOOTER //
// createSuccess.vue?5b3013c4